import { render, staticRenderFns } from "./WorkspaceSettingsTeam.vue?vue&type=template&id=6eca28c8&scoped=true"
import script from "./WorkspaceSettingsTeam.vue?vue&type=script&lang=js"
export * from "./WorkspaceSettingsTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eca28c8",
  null
  
)

export default component.exports